module.exports = __webpack_public_path__ + "static/media/couple_two.4ec1eec6.jpeg";